import { kulturaService } from '../services/kultura.service';
import Vue from 'vue';

const state = {
    kultura: [],
    sezona:null,
    pridelovalecid:null
};

const actions = {
    load({ dispatch,commit },{sezona,pridelovalecid,makeEditable}) {
         dispatch('alert/clear', "",{ root: true });
        commit('setSezona', sezona)
        commit('setPridelovalecID', pridelovalecid)
      return kulturaService.load(sezona,pridelovalecid)
            .then(
                kultura => {
                  commit('load', kultura);
                  if(makeEditable)
                  commit('makeEditable') 
                  return kultura;                   
                } 
                
            );
    },
    loadPreteklaSezona({ dispatch,commit },{sezona,pridelovalecid,makeEditable}) {
         dispatch('alert/clear', "",{ root: true });
        //commit('setSezona', sezona)
        //commit('setPridelovalecID', pridelovalecid)
        return new Promise((resolve, reject) => {

        
       kulturaService.loadPreteklaSezona(sezona,pridelovalecid)
            .then(
                kultura => {
                
                    kultura.forEach(e=>{
                        e.id=null;
                        commit("add",e);
                    });

                  if(makeEditable)
                  commit('makeEditable') 
                  resolve(kultura);                   
                },
                error =>{
                    console.log("Nalaganje ni uspelo");
                    dispatch('alert/error', error, { root: true });
                    reject(error);
                }
                
            );
        });
    },
    loadVse({ dispatch,commit },{sezona}) {
           dispatch('alert/clear', "",{ root: true });
        commit('load');
          commit('setSezona', sezona)
       return  kulturaService.loadAll(sezona)
            .then(
                kultura => commit('load', kultura)
                //,
                //error => commit('getLoggedInFailure', error)
            );
    },
     
    save({ dispatch, commit }) {
     

         console.log("Shranjujem!");
        let sezona=this.state.kultura.sezona;
        let pridelovalecid=this.state.kultura.pridelovalecid;
        console.log(this.state);
        dispatch('alert/clear', "",{ root: true });

        this.state.kultura.kultura.forEach(item=>{
            item.sezona=sezona;
            item.pridelovalecid=pridelovalecid;
            console.log(item);
            if(!item.kulturaid) {
                 item.saved=false;
                dispatch('alert/error', "Šifrant ni ustrezno izbran", { root: true });

            }
            else if(item.jeaktivna){
              kulturaService.save(item)
               .then(
                kultura => {
                    Vue.set(item,"id",kultura.id);
                    Vue.set(item,"saved",true);
                    Vue.set(item,'jeaktivna',1);
                    
                    //commit("update",item);
                    
                },
                error => {
                    console.log("Shranjevanje ni uspelo");
                          Vue.set(item,'saved',false);
             
                    dispatch('alert/error', error, { root: true });
                }
            );
            }
            else
             kulturaService.remove(item).then(
                kultura => {
                     Vue.set(item,'saved',true);
                  
                    
                },
                error => {
                    console.log("Brisanje ni uspelo");
                   Vue.set(item,'saved',false);
                  
                    dispatch('alert/error', error, { root: true });
                }
            //tukaj naredi ikono, da je shranjvanje uspešno na začetku ali nekje
            //uporabi info, če je prišlo kje do napake!

          );
       
        
    });
    }
};

const mutations = {
  
    load(state, kultura) {

        if(kultura)
        state.kultura=kultura.map(k=>{
            k["veljavnostcertifikataod"]=kendo.parseDate(k["veljavnostcertifikataod"]) 
            return k;
        }
            );   

    //      = kultura;
    },
   
    add(state, item) {
        if(!item.id) {
            //do id
            var minid=state.kultura.reduce((prev, curr) => prev.id < curr.id ? prev : curr,{id:0}).id;
            if(minid>0)
                minid=0;
            minid--;
            item.id=minid;
        }
        state.kultura.push(item);
    },
    setSezona(state, item) {
        state.sezona=item;
    },
    makeEditable(state){
        for (var i=0;i<state.kultura.length;i++){
            let dateStr=state.kultura[i].veljavnostcertifikataod;
            if(dateStr)
                state.kultura[i].veljavnostcertifikataod=new Date(dateStr);
            else
                state.kultura[i].veljavnostcertifikataod=new Date( );
            let updated = Object.assign({}, state.kultura[i], { inEdit: true });
            state.kultura.splice(i,1,updated);
        }
        

    },
    setPridelovalecID(state, item) {
        state.pridelovalecid=item;
    },
  
    update(state, item) {
        //state.kultura = kultura;
        //state.kultura;
       
        let updated;
        let itemID = item.id
            let index = state.kultura.findIndex(p =>
                (JSON.stringify({ ...p }) === JSON.stringify(item) )
                 || itemID && p.id === itemID);
            if (index >= 0) {
                updated = Object.assign({}, item);
                state.kultura.splice(index,1,updated);
            } else {
                let id = 1;
                state.kultura.forEach(p => { id = Math.max(p.id + 1, id); });
                updated = Object.assign({}, item, { id: id });
                state.kultura.unshift(updated);
                index = 0;
            }



        //    return data[index];
        //state.kultura=data;

    },
    remove(state, item) {
        let itemID = item.id
            let index = state.kultura.findIndex(p =>
                (JSON.stringify({ ...p }) === JSON.stringify(item) )
                 || itemID && p.id === itemID);
                console.log("Brisem!");
                console.log(index);
                console.log(state.kultura);
                state.kultura.splice(index, 1);
        
        //    return data[index];
        //state.kultura=data;

    },
    replace(state, kultura) {
        state.kultura = kultura;
    }
   
};

export const kultura = {
    namespaced: true,
    state,
    actions,
    mutations
};
